import { configureStore } from '@reduxjs/toolkit';
import HomeMaster from '../features/HomeMaster';
import ModalSlice from '../features/ModalSlice';

export const store = configureStore({
  reducer: {
    modalState: ModalSlice,
    homeMaster: HomeMaster,
  },
});
